import React, { type JSX } from "react";

export const SECTION_CLASS = "bg-white shadow rounded-lg";
export const SECTION_BODY_CLASS = "px-6 py-5 space-y-6";
export const SECTION_FOOTER_CLASS =
  "px-6 py-4 bg-gray-50 border-t border-gray-200 flex justify-end";

const TOGGLE_BASE =
  "relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2";
const KNOB_BASE =
  "pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out";

/** Section title and explanatory copy. */
export function SectionHeader({
  title,
  description,
}: {
  title: string;
  description: string;
}): JSX.Element {
  return (
    <div className="px-6 py-5 border-b border-gray-200">
      <h3 className="text-lg font-medium leading-6 text-gray-900">{title}</h3>
      <p className="mt-1 text-sm text-gray-500">{description}</p>
    </div>
  );
}

/** Sliding on/off switch. */
export function ToggleSwitch({
  id,
  checked,
  onChange,
  onClass,
  srLabel,
  labelledBy,
}: {
  id?: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  onClass: string;
  srLabel?: string;
  labelledBy?: string;
}): JSX.Element {
  return (
    <button
      id={id}
      type="button"
      onClick={() => onChange(!checked)}
      className={`${checked ? onClass : "bg-gray-200"} ${TOGGLE_BASE}`}
      role="switch"
      aria-checked={checked}
      aria-labelledby={labelledBy}
    >
      {srLabel && <span className="sr-only">{srLabel}</span>}
      <span
        aria-hidden="true"
        className={`${checked ? "translate-x-5" : "translate-x-0"} ${KNOB_BASE}`}
      />
    </button>
  );
}
